import React, { useState, useEffect } from "react";
import { Row, Card, CardHeader, CardBody, Col } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { NEWDISCOUNT } from "../../helpers/data_helper";
import Loader from "../../Components/Common/Loader";
import moment from "moment";

const DailyDiscountDistribution
  = ({ chartMax = 160, mealPeriod, leftFilter, discountCodes, serveList }) => {
    const labelColors = ["#ff6b6b", "#9b87f5", "#0ea5e9", "#f97316", "#4ecdc4", "#a855f7", "#ec4899", "#f43f5e", "#f59e0b", "#10b981"]
    const [categories, setCategories] = useState([]);
    const [series, setSeries] = useState([]);
    const [loading, setLoading] = useState(false)

    const options = {
      chart: {
        type: "bar",
        stacked: true,
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
          borderRadius: 5,
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories,
        labels: {
          style: { colors: "#000", fontSize: "12px" },
        },
      },
      yaxis: {
        min: 0,
        max: chartMax,
        labels: {
          style: { colors: "#000", fontSize: "12px" },
        },
      },
      tooltip: {
        shared: true,
        intersect: false,
      },
      legend: {
        show: true,
        position: "bottom",
        horizontalAlign: "center",
        labels: {
          colors: "#000",
          useSeriesColors: false,
        },
      },
      fill: {
        opacity: 1,
      },
      colors: labelColors// Matching colors from the image
    };

    useEffect(() => {
      setLoading(true)
      postDataAPI({
        serviceName: NEWDISCOUNT.serviceName,
        op: NEWDISCOUNT.op_daily_discount_distribution,
        leftFilter: leftFilter,
        mealPeriod: mealPeriod,
        server_id: serveList,
        discount_id: discountCodes,
      }).then((response) => {
        if (response.status === "ok") {
          for (let i = 0; i < response?.data?.data.length; i++) {
            const obj = response?.data?.data[i].data;
            for (let key in obj) {
              if (parseInt(obj[key]) === 0) {
                delete obj[key];
              }
            }
          }

          const dateDataset = new Set();
          response?.data?.data.forEach(item => {
            Object.keys(item.data).forEach(date => {
              dateDataset.add(date);
            });
          });
          const categories = Array.from(dateDataset).sort()
          setCategories(categories.map(data => {
            return moment(data).format('MM/DD')
          }))

          const chartData = categories.map(date => {
            const entry = { category: date };
            response?.data?.data.forEach(item => {
              entry[item.name] = item.data[date] || undefined;
            });
            return entry;
          });

          const userKeys = chartData[0]
            ? Object.keys(chartData[0]).filter(k => k !== "category")
            : [];

          const series = userKeys.map(name => ({
            name: name,
            data: chartData.map(item => {
              const value = item[name];
              return value && Number(value) > 0 ? Number(value) : null;
            })
          }));
          setSeries(series)
        }
        setLoading(false);

      });

    }, [mealPeriod, leftFilter, discountCodes, serveList]);




    return (
      <Row>
        <Card>
          <CardHeader className="ps-0 border-0 align-items-center d-flex">
            <div className="d-flex align-items-start">
              <div
                className="bg-danger me-3 d-flex justify-content-center align-items-center"
                style={{
                  borderRadius: "10px",
                  height: "40px",
                  width: "40px",
                  color: "white",
                }}
              >
                <i className="ri-bar-chart-fill" style={{ fontSize: "25px" }} />
              </div>

              <div>
                <h4 className="card-title mb-0 flex-grow-1">
                  Daily Discount Distribution
                </h4>
                <p className="text-muted mb-0">
                  Stacked discount counts by type and day (30 days)
                </p>
              </div>
            </div>
          </CardHeader>

          {loading && <Loader />}
          <div className={loading ? 'opacity-0' : ''}>

            <ReactApexChart
              options={options}
              series={series}
              type="bar"
              height={350}
            />

            {/* <hr /> */}
          </div>
        </Card>
      </Row>
    );
  };

export default DailyDiscountDistribution;
